import gql from 'graphql-tag';

export const USER_ME = gql`

  query userMe {
    user {
      me {
        user {
          id
          email
          login
          role
          companyId
          market {
            id
            name
          }
        }
      }
    }
  }
`;
